import React, { useState, useContext } from 'react';
import '../../styles/landing.css'
import '../../styles/herobanner.css'
import { Link } from 'react-router-dom';
import * as Constants from '../../constants';
import HeroBanner from '../../components/herobanner';
import DynamicIcon from '../../components/dynamicicon';
import PublicHeader from '../../components/public/publicheader';
import HeroOne from '../../components/public/HeroOne';
import { ServicesSection } from '../../landing/components/ServicesSection';

function LandingPage() {
  const iconcolor="#0000ff";
  const iconSizeBig=44;
  const iconSizeSmall=24;
 

  return (
    <div className='landing'>
      
    <PublicHeader page="home" />

<HeroBanner></HeroBanner>
{/* <MobileHeroBanner/> */}

 <div className='mobileTag'>
  <h2>Lagos State Judiciary Website</h2>
 </div>
{/* <HeroOne/> */}

<ServicesSection />

<section class="about-section">
  <div class="about-container">
   
    <div class="about-media">
      <div class="main-image">
        <img src={`${Constants.baseurl}/assets/landing/jis-gov.jpg`} alt="image" />
        <div class="client-badge">
          <h3>500k+</h3>
          <p>Cases</p>
        </div>
        <div class="image-box">
          <img src={`${Constants.baseurl}/assets/landing/chief_justice_1.png`} alt="thumbnail" />
        </div>
      </div>
    </div>

    
    <div class="about-content">
      <div class="label"><i data-lucide="upload-cloud"></i> ABOUT JIS</div>
      <h2>Welcome to Lagos State Judiciary</h2>
      <p>Welcome to Lagos State Judiciary web site. We are committed to ensuring disputes are resolved fairly, timely, transparently and economically by leveraging enabling technology with inherent seamless integration of the court processes, structures and administration. We provide automated case processing, payments and communication through this online court system to make it easy for various parties to a case to have timely access to pertinent case-related information.</p>
      <p>The Lagos High Court System is comprised of The Criminal Division, The Lands Division, The Family and Probate Division, The Commercial (Fast Track) Division, The General Civil Division, The Special Offences Courts and The Sexual Offences Courts. The rules and procedures governing the operations of the Lagos State High Court is of Lagos State (Civil Procedure) Rules 2019. The Lagos State Judiciary has a rich heritage.</p>



      <div class="cta-buttons">
        <a href="#" class="btn-primary">Login now</a>
        <a href="tel:+25632542598" class="btn-call">
          <div>
            <small>Call Now!</small><br />
            <strong>(+234) 92362 84623</strong>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="commitment-section">
  <div class="commitment-container">
    <div class="commitment-image">
      <img src={`${Constants.baseurl}/assets/landing/commitment.jpeg`} alt="Judiciary Expert Consultation" />
    </div>
    <div class="commitment-content">
      <div class="section-header">
        <h5><i data-lucide="sparkles"></i> Commitment Statement</h5>
        <h2>Mission for Lagos State Judiciary</h2>
        <p>
          We the staff of Lagos State Judiciary are committed to Lagos State and the Community. Our mission is to provide quality and professional service in a knowledgeable manner. We take pride in our work and hold ourselves accountable to the highest standard of performance. Our goals are achieved through mutual co-operation, a strong sense of integrity, a positive attitude and teamwork.
        </p>
      </div>

      <div class="commitment-points">
        <div class="commitment-item">
          <div class="icon-circle">
            <DynamicIcon iname="work" style={{color:iconcolor}} size={iconSizeSmall}/>
            </div>
          <div>
            <h4>Discipline</h4>
            <p>Ethical standards and accountability measures that ensure judges act with integrity, impartiality, and professionalism.</p>
          </div>
        </div>

        <div class="commitment-item">
          <div class="icon-circle">
            <i data-lucide="handshake"></i>
             <DynamicIcon iname="handshake" style={{color:iconcolor}}
              size={iconSizeSmall}/>
            </div>
          <div>
            <h4>Honesty</h4>
            <p>Ensuring confidence, upholding ethical conduct and commitment to fairness, intergrity and Justice.</p>
          </div>
        </div>

        <div class="commitment-item">
          <div class="icon-circle">
            <DynamicIcon iname="handshake" style={{color:iconcolor}}
              size={iconSizeSmall}/>
          </div>
          <div>
            <h4>Hardwork</h4>
            <p>Ensures fair judgments, prevents corruption, and upholds justice.</p>
          </div>
        </div>

        <div class="commitment-item">
          <div class="icon-circle">
            
            <DynamicIcon iname="scale" style={{color:iconcolor}}
              size={iconSizeSmall}/>
            </div>
          <div>
            <h4>intergrity</h4>
            <p>Ensuring confidence, upholding ethical conduct and commitment to fairness, intergrity and Justice.</p>
          </div>
        </div>

        <div class="commitment-item">
          <div class="icon-circle">
            <i data-lucide="award"></i>
            <DynamicIcon iname="award" style={{color:iconcolor}}
              size={iconSizeSmall}/>
            </div>
          <div>
            <h4>Credence, Dignity, and Honour</h4>
            <p>dedication, research, and persistence in handling legal matters.</p>
          </div>
        </div>

        <div class="commitment-item">
          <div class="icon-circle">
            
            <DynamicIcon iname="trophy" style={{color:iconcolor}}
              size={iconSizeSmall}/>
            </div>
          <div>
            <h4>Zeal for Result and Excellency</h4>
            <p>provide quality and professional service in a knowledgeable manner.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<footer class="footer">
  <div class="subscribe-section">
    <h2>Book an Appointment</h2>
    <form class="subscribe-form">
      <input type="email" placeholder="Email Address" />
      <button type="submit">Message Now</button>
    </form>
  </div>

  <hr />

  <div class="footer-content">
    <div class="footer-col">
      <h4>About JIS</h4>
      <p>
        The Lagos State Judiciary is the oldest Judiciary in Nigeria. Its existence dates back to the period of the Cession of Lagos to the British Government when it was established and known as the Colony Province Judiciary.
      </p>
      <div class="social-icons">
        <a href="#"><i data-lucide="facebook"></i></a>
        <a href="#"><i data-lucide="twitter"></i></a>
        <a href="#"><i data-lucide="linkedin"></i></a>
        <a href="#"><i data-lucide="instagram"></i></a>
      </div>
    </div>

    <div class="footer-col">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="#">Nigeria Bar Association</a></li>
        <li><a href="#">Nigeria Bar Library</a></li>
        <li><a href="#">Frequently adked Questions</a></li>
        <li><a href="#">Gallery</a></li>
        <li><a href="#">Contact Us</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="#">Lagos State Government</a></li>
        <li><a href="#">Lagos Automated Probate Registry</a></li>
        <li><a href="#">LSJ Email login</a></li>
        <li><a href="#">Lagos state remote court (Igbosere)</a></li>
        <li><a href="#">Lagos State remote Court 2 (Ikeja)</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4>Our Mission Statement</h4>
      <ul>
        <li><a href="#">Discipline</a></li>
        <li><a href="#">Honesty</a></li>
        <li><a href="#">Hardwork</a></li>
        <li><a href="#">Intergrity</a></li>
        <li><a href="#">Credence, Dignityn and Honour</a></li>
        <li><a href="#">Zeal for results and Excellence</a></li>
      </ul>

    </div>
  </div>

  <hr />

  <div class="footer-bottom">
    <p>
      Copyright &copy; 2025 <a href="#">Lagos State Judiciary</a>. All Rights Reserved.
    </p>
    <p>Powered by First Hightower Infotech</p>
    <div class="footer-links">
      <a href="#">Terms & Condition</a>
      <a href="#">Careers</a>
      <a href="#">Privacy Policy</a>
    </div>
  </div>
</footer>


</div>
  );
}

export default LandingPage;